import { assetService } from '@shared/services';
import { UserStore } from '@shared/store';

export const useCountryAsset = () => {
  const { userCountryCurrency } = UserStore.useUserStore;
  const countryAsset = assetService.getAsset(userCountryCurrency);
  return countryAsset;
};
